import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Box,
  Button,
  Input,
  FormControl,
  Text,
  Flex,
  Image,
  useBreakpointValue,
  useColorModeValue
} from "@chakra-ui/react";
import Swal from 'sweetalert2';
import { useColorMode } from "@chakra-ui/react";
import LoginController from "../../controllers/Login/LoginController";
import logo from '../../assets/img/logo_speech.png';
import outstand from '../../assets/img/logo_outstand.png';

function PasswordRecovery() {
  const { toggleColorMode } = useColorMode();
  const history = useHistory();

  useEffect(() => {
    const currentColorMode = localStorage.getItem('chakra-ui-color-mode');
    if (!currentColorMode) {
      toggleColorMode();
      localStorage.setItem('chakra-ui-color-mode', 'dark');
    }
  }, [toggleColorMode]);

  const [codigo, setCodigo] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmaNovaSenha, setConfirmaNovaSenha] = useState("");

  const showToast = (icon, title) => {
    Swal.fire({
      icon,
      title,
      toast: true,
      position: "top",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      }
    });
  };

  const handlePasswordReset = async () => {

    const codigo = localStorage.getItem('codigo');
    const publicCode = localStorage.getItem('publicCode');

    console.log("Código:", codigo);
    console.log("Public Code:", publicCode);

    if (!novaSenha || !confirmaNovaSenha) {
      showToast("error", "Todos os campos são obrigatórios.");
      return;
    }

    if (novaSenha !== confirmaNovaSenha) {
      showToast("error", "As senhas não coincidem.");
      return;
    }


    if (!codigo) {
      showToast("error", "Erro:Codigo não encontrado.");
      return;
    }

    try {
      const response = await fetch("https://app.customervoice.com.br/api/v1/users_page/forgot/change", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          public_code: Number(publicCode),
          code: Number(codigo),
          password: novaSenha,
        }),
      });
  
      const data = await response.json();
  
      if (response.ok) {
        showToast("success", "Senha alterada com sucesso!");
        history.push("/login");
      } else {
        showToast("error", `Erro: ${data.message || "Falha na alteração de senha."}`);
      }
    } catch (error) {
      console.error("Erro ao alterar senha:", error);
      showToast("error", "Erro ao se conectar com o servidor.");
    }

   


  };

  const showVideo = useBreakpointValue({ base: false, md: true });
  const backgroundColor = useColorModeValue("white", "black");

  return (
    <Flex h="100vh" direction={{ base: "column", md: "row" }}>
      {showVideo && (
        <Box flex="1" position="relative" overflow="hidden">
          <video
            autoPlay
            loop
            muted
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              opacity: "0.7",
            }}
          >
            <source src={require("../../assets/movies/login_video.webm")} type="video/mp4" />
            Seu navegador não suporta a tag de vídeo.
          </video>
          <Image
            src={outstand}
            alt="Company Name"
            position="absolute"
            top="100px"
            left="130px"
            boxSize="650px"
            objectFit="contain"
            style={{ filter: "drop-shadow(4px 2px 0px white) drop-shadow(2px 2px 2px gray)" }}
          />
        </Box>
      )}

      <Flex
        flex="1"
        align="center"
        justify="center"
        bg={backgroundColor}
        color={useColorModeValue("black", "white")}
        p="10"
      >
        <Box maxW="400px" w="100%" textAlign="center">
          <Image
            src={logo}
            alt="Customer Voice Logo"
            mx="auto"
            mb="4"
            boxSize="150px"
            objectFit="contain"
            style={{ filter: "drop-shadow(4px 2px 1px) drop-shadow(4px 2px 1px black)" }}
          />

          <Text fontSize="xl" fontWeight="bold" mb="4">
            Recuperação de Senha
          </Text>
          <FormControl>
            <Input
              type="password"
              placeholder="Nova Senha"
              mb="2"
              size="md"
              value={novaSenha}
              onChange={(e) => setNovaSenha(e.target.value)}
              bg="gray.800"
              color="white"
              _placeholder={{ color: "gray.400" }}
              id="new-password"
            />
            <Input
              type="password"
              placeholder="Confirmar Nova Senha"
              mb="2"
              size="md"
              value={confirmaNovaSenha}
              onChange={(e) => setConfirmaNovaSenha(e.target.value)}
              bg="gray.800"
              color="white"
              _placeholder={{ color: "gray.400" }}
              id="confirm-new-password"
            />
            <Button colorScheme="blue" size="md" w="full" onClick={handlePasswordReset} mt="4">
              Cadastrar Nova Senha
            </Button>

            <Button colorScheme="blue" size="md" w="full" mt="2" onClick={() => history.push("/login")}>
              Voltar Login
            </Button>
          </FormControl>
        </Box>
      </Flex>
    </Flex>
  );
}

export default PasswordRecovery;
